// eslint-disable-next-line import/prefer-default-export
export const packingAudit = [
  {
    key: 'CONSOLIDATE_DELIVERY',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Consolidate delivery.',
  },
  {
    key: 'PALLETIZED_CARTONS',
    icon: 'icon-start-loading',
    color: 'dot-dark-brown',
    description: 'Palletized cartons.',
  },
  {
    key: 'CREATE_SHIPMENT',
    icon: 'icon-material-source',
    color: 'dot-dark-blue',
    description: 'Shipment created.',
  },
  {
    key: 'ROUTE_TO_TRAFFIC',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Route to traffic',
  },
  {
    key: 'BACK_ORDER',
    icon: 'icon-material-source',
    color: 'dot-dark-blue',
    description: 'Back ordered',
  },
  {
    key: 'MIS_SCANNED',
    icon: 'icon-start-loading',
    color: 'dot-dark-brown',
    description: 'Mis scanned',
  },
  {
    key: 'CANCEL_DELIVERY',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Cancel delivery',
  },
  {
    key: 'HANDOVER_COMPLETE',
    icon: 'icon-start-loading',
    color: 'dot-dark-brown',
    description: 'Handover completed',
  },
  {
    key: 'CARTON_MULTIPLIER',
    color: 'dot-dark-blue',
    icon: 'dot-dark-blue',
    description: 'Carton multiplier',
  },
  {
    key: 'PRINT_DOCUMENT',
    icon: 'icon-print',
    color: 'dot-dark-green',
    description: 'Print document',
  },
  {
    key: 'RE_OPENED_DELIVERY',
    icon: 'icon-material-source',
    color: 'dot-dark-blue',
    description: 'Re open delivery',
  },
  {
    key: 'RE_SHIPPED_DELIVERY',
    color: 'dot-dark-blue',
    icon: 'icon-material-source',
    description: 'Re ship delivery',
  },
  {
    key: 'RE_SHIP_ERROR',
    color: 'dot-dark-blue',
    icon: 'icon-material-source',
    description: 'Re shih delivery Error',
  },
  {
    key: 'RE_SHIPPED_DELIVERY_PROCESSING',
    color: 'dot-dark-blue',
    icon: 'icon-material-source',
    description: 'Re shih delivery processing',
  },
  {
    key: 'RE_TRIGGERED_DELIVERY',
    icon: 'icon-material-source',
    color: 'dot-dark-green',
    description: 'Re trigger delivery',
  },
  {
    key: 'CARTON_AUDIT',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Carton audit',
  },
  {
    key: 'CREATE_DELIVERY',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Create delivery',
  },
  {
    key: 'MOVED_TO_DOCK',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Move to dock',
  },
  {
    key: 'MOVE_BACK_TO_INDENTED',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Move back to indented',
  },
  {
    key: 'DELETE_CARTON',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Delete carton',
  },
  {
    key: 'RELEASE_DELIVERY',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Release delivery',
  },
  {
    key: 'GENERATE_DOCUMENTS',
    icon: 'icon-start-loading',
    color: 'dot-dark-green',
    description: 'Generate documents',
  },
  {
    key: 'RE_ASSIGNED_BENCH',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Re-assign bench',
  },
  {
    key: 'INDENT_CANCEL',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Indent cancel',
  },
  {
    key: 'INDENT_DELIVERED',
    icon: 'icon-start-loading',
    color: 'dot-dark-green',
    description: 'Indent delivered',
  },
  {
    key: 'RE_PACK',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Re-pack',
  },
  {
    key: 'START_PACKING',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Start packing',
  },
  {
    key: 'EDIT_PACKING',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'Edit packing',
  },
  {
    key: 'DE_CONSOLIDATION',
    icon: 'icon-start-loading',
    color: 'dot-dark-blue',
    description: 'De-consolidate delivery',
  },
];
